import { observer } from 'mobx-react-lite'
import { Alert, Breadcrumbs, Button, FullPageWrapper, SpinnerLoader, Typography } from 'shared/ui'
import { pluralize } from 'shared/lib'
import { CombinedPriceInfo } from 'entities/Billing'
import { MembersPath } from 'pages/settings/pages/members/route/membersPath'
import {
  AddMembersProvider,
  useAddMembersContext,
} from 'pages/settings/pages/members/pages/addMembers/context/addMembersContext'
import {
  InviteCandidatesTable,
  MemberEmailField,
} from 'pages/settings/pages/members/pages/addMembers/ui'
import styles from './styles.module.scss'

const AddMembersContent = observer(() => {
  const {
    isPageLoading,
    sendInvites,
    isSendingInvites,
    inviteCandidateRows,
    combinedPriceInfoStore,
    isTrial,
    sendInvitesDisabled,
  } = useAddMembersContext()

  if (isPageLoading) {
    return <SpinnerLoader ariaLabel='AddMembers_loading' />
  }

  const showSeatsInfo = inviteCandidateRows.length > 0

  return (
    <FullPageWrapper className={styles.wrapper}>
      <Breadcrumbs customPath={`/${MembersPath.root}`} className={styles.breadcrumbs} />
      <div className={styles.header}>
        <Typography variant='heading-lg' ariaLabel='AddMembers_title'>
          Add members
        </Typography>
        <Typography variant='body-md-regular' ariaLabel='AddMembers_subtitle' color='tertiary'>
          Invite your teammates to Salesmsg. Set their role and inbox before sending the invite.
        </Typography>
      </div>
      <div className={styles.content}>
        <div>
          {isTrial && (
            <Alert
              item={{
                type: 'infoLight',
                desc: 'Trial users can add only 1 additional member',
              }}
              marginBottom={16}
            />
          )}
          <MemberEmailField />
        </div>
        <InviteCandidatesTable />
        {showSeatsInfo && !isTrial && (
          <div className={styles.seatsInfo}>
            <CombinedPriceInfo priceInfoStore={combinedPriceInfoStore} />
          </div>
        )}
        <Button
          className={styles.sendInviteButton}
          text={pluralize(inviteCandidateRows.length, 'Send invite', 'Send invites')}
          onClick={sendInvites}
          loading={isSendingInvites}
          disabled={sendInvitesDisabled}
          fullWidth
        />
      </div>
    </FullPageWrapper>
  )
})

export const AddMembers = () => {
  return (
    <AddMembersProvider>
      <AddMembersContent />
    </AddMembersProvider>
  )
}
